import React, { useState, useEffect } from 'react';
import { api } from '../lib/apiClient';
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react';

export const Testimonials = () => {
  const [items, setItems] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    api.get('/testimonials', { params: { featured: true } })
      .then((r) => setItems(r.data || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setIndex((i) => (i + 1) % items.length), 6000);
    return () => clearInterval(t);
  }, [items.length]);

  if (!items.length) return null;

  const active = items[index];
  const go = (dir) => setIndex((i) => (i + dir + items.length) % items.length);

  return (
    <section className="py-20 bg-white" data-testid="testimonials-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-gray-900 mb-3">What Carriers Say</h2>
        <p className="text-lg text-gray-600 mb-12">Real results from owner operators and fleets we keep loaded.</p>

        <div className="relative bg-gradient-to-br from-blue-50 to-orange-50 rounded-3xl p-8 md:p-12" data-testid="testimonial-card">
          <Quote className="h-12 w-12 text-orange-300 mx-auto mb-6" />
          <div className="flex justify-center gap-1 mb-5">
            {Array.from({ length: active.rating || 5 }).map((_, i) => (
              <Star key={i} className="h-5 w-5 text-yellow-400 fill-yellow-400" />
            ))}
          </div>
          <p className="text-xl md:text-2xl text-gray-800 leading-relaxed mb-8 font-medium">"{active.quote}"</p>
          <div>
            <p className="font-bold text-gray-900 text-lg">{active.name}</p>
            <p className="text-gray-600 text-sm">
              {[active.role, active.company, active.location].filter(Boolean).join(' • ')}
            </p>
          </div>

          {items.length > 1 && (
            <>
              <button onClick={() => go(-1)} data-testid="testimonial-prev" className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center hover:bg-orange-600 hover:text-white">
                <ChevronLeft className="h-5 w-5" />
              </button>
              <button onClick={() => go(1)} data-testid="testimonial-next" className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center hover:bg-orange-600 hover:text-white">
                <ChevronRight className="h-5 w-5" />
              </button>
            </>
          )}
        </div>

        {items.length > 1 && (
          <div className="flex justify-center gap-2 mt-6">
            {items.map((_, i) => (
              <button
                key={i}
                onClick={() => setIndex(i)}
                data-testid={`testimonial-dot-${i}`}
                className={`h-2.5 rounded-full transition-all ${i === index ? 'w-8 bg-orange-600' : 'w-2.5 bg-gray-300'}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
